import React, { useEffect, useState } from "react";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import LoaderComponent from "../../LoaderComponent/LoaderComponent";
import ResetOrdersHeader from "./resetOrdersHeader";
import { resetOrdersTableData } from "./api";
import ResetOrdersMaterialTable from "./resetOrdersMaterialTable";

const ErrorReset = (props) => {
  const theme = createTheme({
    palette: {
      primary: { main: "#fff494" },
      secondary: { main: "#E4D00A" },
    },
    typography: { useNextVariants: true },
  });

  const [isLoading, setIsLoading] = useState(false);
  const [pageSize, setPageSize] = useState(20000);
  const [pageNumber, setPageNumber] = useState(0);
  const [tableData, setTableData] = useState(Array(0));
  const onPageChange = (e) => {
    setPageNumber(e);
  };

  const getTableData = async () => {
    setIsLoading(true);
    try {
      const response = await resetOrdersTableData(pageNumber, pageSize);
      setTableData(response);
    } catch (error) {
      console.log("Error occured when fetching data: ", error);
      setTableData(Array(0));
    }
    setIsLoading(false);
  };
  console.log(tableData);

  useEffect(() => {
    getTableData();
  }, []);

  return (
    <div className="rounded-sm p-[5px] w-full">
      <ResetOrdersHeader getTableData={getTableData} />
      <ThemeProvider theme={theme}>
        {isLoading && <LoaderComponent />}
        {!isLoading && (
          <ResetOrdersMaterialTable
            tableName="ErrorReset"
            tableData={tableData}
            onPageChange={onPageChange}
            setIsLoading={setIsLoading}
            getTableData={getTableData}
          />
        )}
      </ThemeProvider>
    </div>
  );
};
export default ErrorReset;
